import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppHome.';
  public static readonly welcome = `${Id.prefix}welcome`;
  public static readonly last6Months = `${Id.prefix}last6Months`;
  public static readonly last90Days = `${Id.prefix}last90Days`;
  public static readonly last60Days = `${Id.prefix}last60Days`;
  public static readonly last30Days = `${Id.prefix}last30Days`;
  public static readonly last7Days = `${Id.prefix}last7Days`;
  public static readonly last24Hours = `${Id.prefix}last24Hours`;
  public static readonly overviewTab = `${Id.prefix}overviewTab`;
  public static readonly deliveryPipelineTab = `${Id.prefix}deliveryPipelineTab`;
}

export class LangAppHome {
  private constructor() {}
  public static welcome(): string {
    return interpolate(Id.welcome);
  }
  public static last6Months(): string {
    return interpolate(Id.last6Months);
  }
  public static last90Days(): string {
    return interpolate(Id.last90Days);
  }
  public static last60Days(): string {
    return interpolate(Id.last60Days);
  }
  public static last30Days(): string {
    return interpolate(Id.last30Days);
  }
  public static last7Days(): string {
    return interpolate(Id.last7Days);
  }
  public static last24Hours(): string {
    return interpolate(Id.last24Hours);
  }
  public static overviewTab(): string {
    return interpolate(Id.overviewTab);
  }
  public static deliveryPipelineTab(): string {
    return interpolate(Id.deliveryPipelineTab);
  }
}

export class AppHomeModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.welcome, 'Welcome!', 'Welcome message for the dashboard');
    register.add(Id.last6Months, 'Last 6 months', 'Date range label for last 6 months');
    register.add(Id.last90Days, 'Last 90 days', 'Date range label for last 90 days');
    register.add(Id.last60Days, 'Last 60 days', 'Date range label for last 60 days');
    register.add(Id.last30Days, 'Last 30 days', 'Date range label for last 30 days');
    register.add(Id.last7Days, 'Last 7 days', 'Date range label for last 7 days');
    register.add(Id.last24Hours, 'Last 24 hours', 'Date range label for last 24 hours');
    register.add(Id.overviewTab, 'Overview', 'Dashboard tab caption for the filtered overview widgets');
    register.add(Id.deliveryPipelineTab, 'Delivery Pipeline', 'Dashboard tab caption for the delivery pipeline table');
  }
}
